<template>
    <div id="highTaskOngoing">
        <div id="headers">
            <img src="../assets/images/img_31.png" alt="" @click="returnPage">
            <div class="headerText">任务详情</div>
        </div>
        <!-- 头部面板 -->
        <div class="ongoingTop">
            <div class="topPanel">
                <div class="lefts">
                    <span class="tit">剩余时间</span>
                    <span class="num">{{surplusTimes}}</span>
                </div>
                <div class="rights">+{{detailData.tuser_price}}<span>元</span></div>
            </div>
        </div>
        <!-- 信息 -->
        <div class="icons">
            <img :src="detailData.icon?detailData.icon:'../assets/images/img_77.png'" alt="">
            <div class="iconsRight">
                {{detailData.name}}
            </div>
        </div>
        <div class="oneBtn" @click="todownload" v-if="tourl != 'http://'">前往下载</div>
        <!-- 步骤 -->
        <div class="step" v-for="(steps,stepIndex) in detailData.step" :key="stepIndex">
            <div class="title">{{steps.name}}</div>
            <div class="explain">
                    <span>{{steps.des}}</span>
            </div>
            <div class="diagram">
                <img :src="ste.url"  v-preview="ste.url" alt="" v-for="(ste,steInd) in steps.url" :key="steInd">
            </div>
            <div class="enlarge">点击图片进入放大模式</div>
        </div>

        <div class="oneBtn" @click="inSubmitAudit">上传资料</div>

        <div class="gap"></div>

        <popChoose @giveUp="giveUp" @notGiveUp="notGiveUp" v-show="choosePop"></popChoose>
    </div>
</template>

<script>
    import popChoose from '../components/PopChoose.vue'

    import Headers from '../components/headersL'
    export default {
        components:{
            Headers,
            popChoose
        },
        data() {
            return {
                headersText:'任务详情',

                choosePop:false,
                tourl:'',
                detailData:{}, // 详情数据
                surplusTimes:'', // 剩余时间
                timers:null, // 计时器
            }
        },
        mounted() {
            this.changeInitH();
            this.addVisible();
        },
        destroyed() {
            this.removeVisible();
        },
        methods: {
            // 封装 visibilitychange事件
            hiddens(){
                if(!document.hidden){ 
                    clearInterval(this.timers);
                    this.surplusTimes = '';
                    this.changeInitH();
                }
            },
            // 执行 visibilitychange事件
            addVisible(){
                var hidden, state, visibilityChange; 
                if (typeof document.hidden !== "undefined") {
                    hidden = "hidden";
                    visibilityChange = "visibilitychange";
                    state = "visibilityState";
                } else if (typeof document.mozHidden !== "undefined") {
                    hidden = "mozHidden";
                    visibilityChange = "mozvisibilitychange";
                    state = "mozVisibilityState";
                } else if (typeof document.msHidden !== "undefined") {
                    hidden = "msHidden";
                    visibilityChange = "msvisibilitychange";
                    state = "msVisibilityState";
                } else if (typeof document.webkitHidden !== "undefined") {
                    hidden = "webkitHidden";
                    visibilityChange = "webkitvisibilitychange";
                    state = "webkitVisibilityState";
                }
                document.addEventListener(visibilityChange, this.hiddens, false);
            },
            // 移除 visibilitychange事件
            removeVisible(){
                var hidden, state, visibilityChange; 
                if (typeof document.hidden !== "undefined") {
                    hidden = "hidden";
                    visibilityChange = "visibilitychange";
                    state = "visibilityState";
                } else if (typeof document.mozHidden !== "undefined") {
                    hidden = "mozHidden";
                    visibilityChange = "mozvisibilitychange";
                    state = "mozVisibilityState";
                } else if (typeof document.msHidden !== "undefined") {
                    hidden = "msHidden";
                    visibilityChange = "msvisibilitychange";
                    state = "msVisibilityState";
                } else if (typeof document.webkitHidden !== "undefined") {
                    hidden = "webkitHidden";
                    visibilityChange = "webkitvisibilitychange";
                    state = "webkitVisibilityState";
                }
                document.removeEventListener(visibilityChange, this.hiddens, false);
            },
            // 封装执行函数
            changeInitH(){
                if(this.$route.query.ids){
                    this.init();
                } else {
                    this.$toast('请返回高额任务页重新进入该页面')
                }
            },
            // 请求初始化(数据展示)
            init(){
                this.$loading(true);
                let datas = {
                    task_id:this.$route.query.ids
                }
                this.$http.POSTS('volume_task/detail',datas,(res)=>{
                    console.log(res.data)
                    this.detailData = res.data
                    this.tourl = res.data.start_fun_info
                    this.countDownFun(res.data.evolve.cycle_time);
                    this.$loading(false);
                });
            },
            // 封装倒计时
            countDownFun(taskEndTime){
                if(taskEndTime <= 0){
                    this.surplusTimes = '00:00'
                    clearInterval(this.timers)
                } else {
                    this.timeFormat(taskEndTime);
                    this.timers = setInterval(()=>{
                        taskEndTime--;

                        if(taskEndTime <= 0){
                            this.surplusTimes = '00:00'
                            clearInterval(this.timers)
                        } else {
                            this.timeFormat(taskEndTime);
                        }
                        
                    },1000)
                }
            },
            timeFormat(taskEndTime){
                let endTimeMinute = Math.floor(taskEndTime/60%60);
                let endTimeSecond = Math.floor(taskEndTime%60);
                endTimeMinute = endTimeMinute>=10?endTimeMinute:'0'+endTimeMinute;
                endTimeSecond = endTimeSecond>=10?endTimeSecond:'0'+endTimeSecond;
                this.surplusTimes = endTimeMinute+':'+endTimeSecond;
            },

            // 进入 提交审核
            inSubmitAudit:function(){
                this.$router.push({name:'submitAudit',query: {ids:this.$route.query.ids,icons:this.detailData.icon}});
            },
            todownload:function(){
                window.location.href = this.tourl;
            },


            // 返回
            returnPage:function(){
                // this.$router.go(-1);
                if(this.$route.query.ids){
                    this.choosePop = true;
                    // clearInterval(this.timers)
                } else {
                    this.$router.go(-1);
                    clearInterval(this.timers)
                }
            },
            // 弹窗
                // 放弃任务
            giveUp:function(){
                let datas = {
                    task_id:this.$route.query.ids
                }
                this.$http.POSTS('volume_task/untask',datas,(res)=>{
                    this.choosePop = false
                    this.$router.go(-1);
                });
            },
                // 不放弃任务
            notGiveUp:function(){
                console.log("不放弃")
                this.choosePop = false
            }
        },
    }
</script>

<style lang="less" scoped>
    #highTaskOngoing{
        // 导航栏
        #headers{
            width: 375px;
            height: 45px;
            background: linear-gradient(to right,#EB3F47,#E50113);
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            img{
                width: 11px;
                height: 18px;
                position: absolute;
                left: 15px;
                padding: 0 3px;
            }
            .headerText{
                font-size: 15px;
                color: #FFFFFF;
            }
        }
        // 头部面板
        .ongoingTop{
            width:375px;
            height:35px;
            background:linear-gradient(313deg,rgba(229,1,19,1) 0%,rgba(235,63,71,1) 100%);
            .topPanel{
                width:345px;
                height:60px;
                background:rgba(255,255,255,1);
                box-shadow:0px 5px 10px 0px rgba(0,0,0,0.05);
                border-radius:5px;
                border:1px solid rgba(222,222,222,.6);
                margin: 0 15px;
                position: relative;
                top: 8px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .lefts{
                    margin-left: 30px;
                    .tit{
                        font-size:15px;
                        color:rgba(51,51,51,1);
                        line-height:15px;
                    }
                    .num{
                        margin-left: 10px;
                        font-size:20px;
                        color:rgba(51,51,51,1);
                        line-height:20px;
                    }
                }
                .rights{
                    margin-right: 22px;
                    font-size:35px;
                    // font-family: Arial, Helvetica, sans-serif;
                    font-family:'Qds';
                    color:rgba(230,9,26,1);
                    line-height:42px;
                    font-weight: bold;
                    position: relative;
                    top: 4px;
                    span{
                        font-size: 14px;
                    }
                }
            }
        }
        // 信息
        .icons{
            width:315px;
            background:rgba(255,255,255,1);
            box-shadow:0px 5px 10px 0px rgba(0,0,0,0.05);
            border-radius:5px;
            border:1px solid rgba(222,222,222,.6);
            margin: 48px 15px 0;
            padding: 15px;
            display: flex;
            align-items: center;
            img{
                width: 60px;
                height: 60px;
                border-radius: 12px;
            }
            .iconsRight{
                margin-left: 10px;
                font-size: 20px;
            }
        }
        // 步骤
        .step{
            width:315px;
            background:rgba(255,255,255,1);
            box-shadow:0px 5px 10px 0px rgba(0,0,0,0.05);
            border-radius:5px;
            border:1px solid rgba(222,222,222,.6);
            margin: 15px;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 0 15px;
            .title{
                width:130px;
                height:32px;
                background:rgba(249,249,249,1);
                border-radius:0px 0px 8px 8px;
                border:1px solid rgba(222,222,222,.6);
                font-size:13px;
                font-weight:600;
                color:rgba(102,102,102,1);
                line-height:32px;
                text-align: center;
                margin-top: -1px;
            }
            .explain{
                font-size:13px;
                font-weight:400;
                color:rgba(51,51,51,1);
                line-height:20px;
                margin-top: 20px;
            }
            .diagram{
                width: 100%;
                display: flex;
                justify-content: center;
                margin: 10px 0;
                img{
                    width:90px;
                    height:160px;
                    padding: 0 10px;
                }
            }
            .enlarge{
                font-size:13px;
                font-weight:400;
                color:rgba(153,153,153,1);
                line-height:20px;
                padding: 0 0 10px;
            }
        }
        .oneBtn{
            width:250px;
            height:45px;
            background:linear-gradient(313deg,rgba(229,1,19,1) 0%,rgba(235,63,71,1) 100%);
            box-shadow:0px 5px 10px 0px rgba(229,1,19,0.15);
            border-radius:25px;
            font-size:15px;
            font-weight:500;
            color:rgba(255,255,255,1);
            line-height:45px;
            text-align: center;
            margin: 20px auto;
        }
        .gap{
            width: 100%;
            height: 15px;
        }
    }
</style>